import React from 'react';
import { NavLink } from 'react-router-dom';
import { KeyMapKeys } from '@locales/lokalise/keyMap';
import i18next, { i18n } from 'i18next';

export const getSidebarMenuLabel = ({
  name,
  path,
  exact,
  t,
}: {
  name: string;
  path?: string;
  exact?: boolean;
  t: i18n['t'];
}) => {
  if (path) {
    return (
      <NavLink exact={exact} to={path}>
        {t(name as KeyMapKeys)}
      </NavLink>
    );
  }
  return i18next.t(name as KeyMapKeys);
};
